import React from 'react';
const DeleteIcon = (props) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="40" cy="40" r="40" fill="#F9FAFB" />
    <rect x="31.1191" y="19" width="17.2045" height="8.60241" rx="3.03612" fill="#475467" />
    <path
      d="M39.7227 19H45.2888C46.9656 19 48.3249 20.3593 48.3249 22.0361V24.5663C48.3249 26.2431 46.9656 27.6024 45.2888 27.6024H39.7227V19Z"
      fill="#344054"
    />
    <path
      d="M23.5293 30.6406H55.9143L53.6162 58.2181C53.485 59.7917 52.1696 61.0021 50.5905 61.0021H29.313C27.7532 61.0021 26.4472 59.8201 26.292 58.2681L23.5293 30.6406Z"
      fill="#F04438"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.7234 30.6406H23.5312L26.2939 58.2681C26.4491 59.8201 27.7552 61.0021 29.315 61.0021H39.7234V30.6406ZM55.9159 30.6447L55.9162 30.6406H55.9159V30.6447Z"
      fill="#FDA29B"
    />
    <rect x="38.2051" y="33.6719" width="3.03609" height="22.2651" rx="1.51804" fill="#FEFEFE" />
    <rect
      width="3.03609"
      height="22.2651"
      rx="1.51805"
      transform="matrix(0.998629 0.0523369 -0.052335 0.99863 45.3672 33.6094)"
      fill="#E4E7EC"
    />
    <rect
      width="3.03609"
      height="22.2651"
      rx="1.51805"
      transform="matrix(0.998629 -0.0523369 0.052335 0.99863 31.0449 33.7656)"
      fill="#FEFEFE"
    />
    <path
      d="M39.7227 33.6719C40.561 33.6719 41.2407 34.3515 41.2407 35.1899V54.4189C41.2407 55.2573 40.561 55.9369 39.7227 55.9369V33.6719Z"
      fill="#E4E7EC"
    />
    <rect x="33.6504" y="21.5312" width="12.1444" height="5.06024" rx="1.01204" fill="#FEFEFE" />
    <rect x="21" y="24.0625" width="37.4451" height="7.59036" rx="3.79518" fill="#475467" />
    <path
      d="M39.7227 24.0625H54.65C56.746 24.0625 58.4452 25.7617 58.4452 27.8577C58.4452 29.9537 56.746 31.6529 54.65 31.6529H39.7227V24.0625Z"
      fill="#344054"
    />
  </svg>
);

export default DeleteIcon;
